import styled from '@emotion/styled';
import { fontSizes, fontWeights } from 'app/typography';
import Select from 'components/Kizen/Select';
import Loader from 'components/Kizen/Loader';
import Input from 'components/Kizen/Input';

export const ConnectEmailAlert = styled.div`
  margin-bottom: 20px;
  padding: 18px 8px;
  border-radius: 4px;
  background: var(--color-feedback-info-bg);
  font-size: ${fontSizes.text};

  > * {
    font-size: inherit;
  }
`;

export const StyledSelect = styled(Select)`
  margin-bottom: 20px;
`;

export const StyledInput = styled(Input)`
  margin-bottom: 20px;

  span:first-of-type {
    font-weight: ${fontWeights.bold};
  }
`;

export const StyledLabel = styled.div`
  margin-bottom: 12px;
  font-size: ${fontSizes.text};
  font-weight: ${fontWeights.bold};
`;

export const CenteredLoader = styled(Loader)`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 15px 0;
  padding-top: 0 !important;
  transform: translate(-50%, -50%);
`;
